import RichText from "@/components/RichText";

// Aucun module Articles/Blog dans la plateforme à ce jour — "blog_section"
// est une sélection MANUELLE de vignettes (theme_service.BLOCK_TYPES
// ["blog_section"]["article_card"]), pas un flux dynamique. `url` peut
// pointer vers une page interne ou un article externe, d'où <a> plutôt
// qu'un <Link> react-router.
export default function BlogSection({ props = {}, blocks = [] }) {
  const articles = (blocks || []).filter((b) => b.enabled !== false && b.type === "article_card");
  if (!articles.length) return null;

  return (
    <section className="max-w-[1240px] mx-auto px-6 md:px-10 py-section md:py-section-md">
      {props.heading && (
        <RichText
          as="h2"
          className="font-display font-semibold text-[28px] md:text-[32px] leading-tight tracking-[-0.02em] text-ink mb-8"
          html={props.heading}
        />
      )}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {articles.map((block) => (
          <a
            key={block.id}
            data-block-key={block.id}
            href={block.props?.url || "#"}
            className="group flex flex-col gap-3"
          >
            <div className="aspect-[4/3] rounded-xl overflow-hidden bg-sand">
              {block.props?.image_url && (
                <img src={block.props.image_url} alt="" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              )}
            </div>
            {block.props?.title && (
              <RichText
                as="h3"
                className="font-display font-semibold text-[17px] text-ink group-hover:text-gold transition-colors"
                html={block.props.title}
              />
            )}
            {block.props?.excerpt && (
              <p className="text-[14px] text-graphite leading-relaxed">{block.props.excerpt}</p>
            )}
          </a>
        ))}
      </div>
    </section>
  );
}
